import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import DiscussionTranslationManager from 'managers/discussion/translation';
import { IWCCStorageManager } from 'managers/iStorage';
import { CommentsService } from 'services/comments';
import './refreshTranslationButton.html';
import CommentRequestButtonVM, { CommentRequestButtonVMConfig } from './requestButton';

const { discussionId } = settings;

@injectable()
export default class CommentRefreshTranslationButtonVM extends CommentRequestButtonVM {
    private commentId: Subscribable<string | undefined>
    private isTranslationAllowed: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: CommentRequestButtonVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.commentsService) private commentsService: CommentsService
    ) {
        super(config, info);

        this.commentId = this.comment.pluck(c => c.id);

        const translationManager = storage.get(DiscussionTranslationManager, { discussionId });
        this.isTranslationAllowed = translationManager.pluck(m => m.isAllowedToShow, false);        
    }

    refreshTranslation = () => {
        if (this.isBusy()) return;

        system.confirm(messages.AreYouSureYouWantToRefreshThisTranslation, async () => {
            try {
                const commentId = this.commentId();

                if (commentId == undefined)
                    throw new Error(messages.InvalidRequest);

                this.isBusy(true);

                await this.commentsService.refreshTranslation(commentId);

                system.showInfoMessage(messages.TheTranslationWillBeRefreshedSoon);
            } catch (ex) {
                system.handleError(ex);
            } finally {
                this.isBusy(false);
            }
        });
    }

    protected override checkIfVisible() {
        return super.checkIfVisible() && this.isTranslationAllowed();
    }
}